// iter1063 — ЕДИНЕН източник на наименованията в предната част: пълно име
// (`label`) за заглавия на карти и страници, кратко име (`short`) за
// плочките, страница и ЕДНОТО действие, което включва близнака.
// Единният списък на сървъра е backend/services/twin_registry.py; ключовете,
// имената и страниците тук се пазят от разминаване с тест-предпазител
// (tests/test_twin_registry_iter1054.py).
export const TWIN_CATALOG = {
  nutritional: {
    label: "Хранене", short: "Хранене", route: "/dashboard/plate-simulator",
    action_bg: "Запишете едно хранене", action_route: "/dashboard/plate-simulator",
  },
  lab: {
    label: "Лабораторни изследвания", short: "Изследвания", route: "/dashboard/lab-twin",
    action_bg: "Качете резултат от кръвно изследване", action_route: "/dashboard/analyses",
  },
  phenotype: {
    label: "Наследственост", short: "Наследственост", route: "/dashboard/phenotype-twin",
    action_bg: "Попълнете оценката на наследствеността", action_route: "/dashboard/phenotype-twin",
  },
  microbiome: {
    label: "Микробиом и храносмилане", short: "Микробиом", route: "/dashboard/microbiome-twin",
    action_bg: "Попълнете въпросника за храносмилането", action_route: "/dashboard/microbiome-twin",
  },
  body_comp: {
    label: "Телесен състав", short: "Телесен състав", route: "/dashboard/body-comp-twin",
    action_bg: "Въведете тегло", action_route: "/dashboard/body-comp-twin",
  },
  sleep: {
    label: "Сън", short: "Сън", route: "/dashboard/sleep-twin",
    action_bg: "Отбележете една нощ сън", action_route: "/dashboard/sleep-twin",
  },
  stress: {
    label: "Напрежение и душевно състояние", short: "Напрежение", route: "/dashboard/stress-twin",
    action_bg: "Попълнете дневния отчет", action_route: "/dashboard/stress-twin",
  },
  cardio: {
    label: "Сърце и кръвоносни съдове", short: "Сърце", route: "/dashboard/cardio-twin",
    action_bg: "Въведете кръвно налягане", action_route: "/dashboard/cardio-twin",
  },
  hormonal: {
    label: "Хормони и ендокринни оси", short: "Хормони", route: "/dashboard/hormonal-twin",
    action_bg: "Въведете хормонални изследвания", action_route: "/dashboard/hormonal-twin",
  },
  metabolic_insulin: {
    label: "Обмяна и инсулин", short: "Обмяна", route: "/dashboard/metabolic-insulin-twin",
    action_bg: "Въведете кръвна захар или HbA1c", action_route: "/dashboard/metabolic-insulin-twin",
  },
  inflammation: {
    label: "Възпаление", short: "Възпаление", route: "/dashboard/inflammation-twin",
    action_bg: "Въведете hsCRP или феритин", action_route: "/dashboard/inflammation-twin",
  },
  movement: {
    label: "Движение", short: "Движение", route: "/dashboard/movement-twin",
    action_bg: "Запишете крачки или движение", action_route: "/dashboard/movement-twin",
  },
  liver_kidney: {
    label: "Черен дроб", short: "Черен дроб", route: "/dashboard/liver-kidney-twin",
    action_bg: "Качете чернодробни показатели", action_route: "/dashboard/analyses",
  },
  kidney: {
    label: "Здраве на бъбреците", short: "Бъбреци", route: "/dashboard/kidney-intelligence",
    action_bg: "Въведете скорост на филтрация", action_route: "/dashboard/kidney-intelligence",
  },
  dental: {
    label: "Здраве на зъбите и устата", short: "Зъби и уста", route: "/health-intelligence/dental",
    action_bg: "Попълнете въпросника за зъбите", action_route: "/health-intelligence/dental",
  },
  bhi: {
    label: "Здраве на гърдата", short: "Гърда", route: "/health-intelligence/breast",
    action_bg: "Попълнете въпросника за гърдата", action_route: "/health-intelligence/breast",
  },
  hematology: {
    label: "Кръв и кръвотворене", short: "Кръв", route: "/dashboard/hematology-twin",
    action_bg: "Качете кръвна картина", action_route: "/dashboard/analyses",
  },
  neuro: {
    label: "Нервна система и мислене", short: "Нервна система", route: "/dashboard/neuro-twin",
    action_bg: "Попълнете въпросника за нервната система", action_route: "/dashboard/neuro-twin",
  },
  male_health: {
    label: "Мъжко здраве", short: "Мъжко здраве", route: "/dashboard/male-health-twin",
    action_bg: "Въведете тестостерон", action_route: "/dashboard/male-health-twin",
  },
  respiratory: {
    label: "Дишане и кислород", short: "Дишане", route: "/dashboard/respiratory-twin",
    action_bg: "Отбележете задух или насищане с кислород", action_route: "/dashboard/respiratory-twin",
  },
};

export const TWIN_IDS = Object.keys(TWIN_CATALOG);

export const twinLabel = (id) => TWIN_CATALOG[id]?.label || id;
export const twinShort = (id) => TWIN_CATALOG[id]?.short || twinLabel(id);
export const twinRoute = (id) => TWIN_CATALOG[id]?.route || "/dashboard";

// iter1063 — подробните раздели на таблото („…интелигентност") носят
// ИМЕТО НА СВОЯ БЛИЗНАК, за да не се срещат две имена за едно и също нещо.
// `title` се задава само когато разделът е по-тесен от близнака (кортизолът
// е част от близнака „Напрежение и душевно състояние").
export const MODULE_CATALOG = {
  cortisol: {
    twin: "stress", title: "Кортизол и дневен ритъм",
    subtitle: "Профил, ден от 28-дневната програма, дишане",
  },
  khi: { twin: "kidney", subtitle: "Скорост на филтрация, стадий, план за деня" },
  bhi: { twin: "bhi", subtitle: "Метаболитна среда, тъканна възраст, водещо действие" },
  dhi: { twin: "dental", subtitle: "Риск от кариес, венци, връзка с целия организъм" },
  neuro: { twin: "neuro", subtitle: "Чувствителност, вегетативен баланс, възбудимост" },
  hema: { twin: "hematology", subtitle: "Анемичен модел, желязо, В12 и фолат" },
};

export const moduleTitle = (id) =>
  MODULE_CATALOG[id]?.title || twinLabel(MODULE_CATALOG[id]?.twin || id);
export const moduleSubtitle = (id) => MODULE_CATALOG[id]?.subtitle || "";
export const moduleTwinLabel = (id) => twinLabel(MODULE_CATALOG[id]?.twin || id);

export default TWIN_CATALOG;
